import React from 'react'
import Header from '../Header/Header'
import "./ViewHeight.css"
import Form from '../Form'
import image from "../../Images/New Project.png"
export default function ViewHeight() {
  return (
    <div className='ViewHeight'>
      <Header/>

  <div className="CenterView">
    <Form />
</div>
    </div>
  )
}
